export interface IntakeFormSectionOption {
  value: string;
  label: string;
  // Names the form was stored under before a rename.
  aliases?: readonly string[];
}

// Stored form names gain spaces (`(PrimerMD)` comes back as `(Primer MD)`), so match without whitespace.
const toFormToken = (name: string): string =>
  name.replace(/\s+/g, "").toLowerCase();

const sectionNames = (section: IntakeFormSectionOption): string[] => [
  section.value,
  section.label,
  ...(section.aliases ?? []),
];

/** Whether `forms` (an array or a comma-separated string) contains `section` by key, label or alias. */
export const hasIntakeForm = (
  forms: string | readonly string[] | undefined | null,
  section: IntakeFormSectionOption
): boolean => {
  const formNames =
    typeof forms === "string" ? forms.split(",") : (forms ?? []);
  const sectionTokens = sectionNames(section).map(toFormToken);
  return formNames.some((form) => sectionTokens.includes(toFormToken(form)));
};

/** The saved values of `section`, under its current key or one it was stored under before. */
export const getIntakeFormValues = <T>(
  values: object | undefined,
  section: IntakeFormSectionOption
): T | undefined =>
  sectionNames(section)
    .map(
      (name) => (values as Record<string, T | undefined> | undefined)?.[name]
    )
    .find((value) => value !== undefined);
